import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import VueCookie from 'vue-cookie'

const routerOptions = [

    // ================================================ Root =======================================================

    // ================================================ Dashboard =======================================================

    { path: '/', name: 'New Home Dashboard', componentPath: 'Dashboard/EmployeeDetails/MainDashboard' },
    // NOTE: The new DashboardClockActionPopup (Manual + Face Recognition) is integrated
    // into the existing employee dashboard above. To test: log in as employee and click
    // Clock-In / Add Break / Clock-Out / Resume. The Resume button also uses the new popup.
    { path: '/payroll_dashboard', name:"Payroll Dashboard", componentPath: 'Dashboard/Payroll/MainDashboard' },
    // ==============  Employee Info ====================//
    { path: "/employee_info/list/:onboard?", name: "Employee Info List", componentPath: 'Employee/EmployeeListgridViewNew'},
    { path: "/employee_info/payrolls/list/:type", name: "Payrolls List", componentPath: 'Employee/PayrollNewTheme/PayrollListView'},
    // { path: "/payslip/", name: "Payslip", componentPath: 'Employee/PayslipGenerate'},
    // { path: "/payslip/edit/:id", name: "Payslip", componentPath: 'Employee/PayslipGenerate'},
    { path: "/payslip/view/:id", name: "Payslip", componentPath: 'Employee/PayslipGenerate'},
    // { path: "/employee_info/timesheet/list", name: "Timesheet List", componentPath: 'Employee/TimeSheetListView'},
    { path: "/employee_info/timesheet/list/:type", name: "Timesheet List", componentPath: 'Employee/TimesheetNewTheme/TimesheetListView'},
    { path: "/employee_info/create", name: "Employee Create", componentPath: 'Employee/CreateEditEmployee'},
    { path: "/employee_info/edit/:id/:my_profile/:is_draft", name: "Employee Edit", componentPath: 'Employee/CreateEditEmployee'},
    { path: "/employee_info/view/:id/:my_profile/:is_draft", name: "Employee View", componentPath: 'Employee/CreateEditEmployee'},
    { path: "/employee_info/myshift_details/:details_type", name: "Myshift Details", componentPath: 'Employee/MyShiftDetails'},
    // ==============  Timesheet ====================//
    { path: "/timesheet", name: "Timesheet", componentPath: 'Employee/TimesheetNewTheme/TimeSheetApprovalRejectListView'},
    // Payroll
    { path: "/employee_info/payroll", name: "Employee Payroll", componentPath: 'Home', meta: { requiresAuth: true }},
    // Asset Details
    { path: "/employee_info/asset_details", name: "Employee Asset Details", componentPath: 'Home', meta: { requiresAuth: true }},
    // Attendance List
    { path: "/employee_info/attendance_list", name: "Employee Attendance", componentPath: 'Employee/AttendanceNewTheme/Admin/ListEmployeeDetails'},
    { path: "/employee_info/hr_attendance/:id", name: "HR Attendance", componentPath: 'Employee/AttendanceNewTheme/Admin/AttendanceListView'},
    { path: "/attendance_management/dashboard", name: "Attendance Management Dashboard", componentPath: 'Employee/AttendanceManagement/Dashboard'},
    { path: "/attendance_management/clock_in_out", name: "Clock In Out", componentPath: 'Employee/AttendanceManagement/ClockInOut'},
    { path: "/attendance_management/register_employees_list", name: "Register Employees List", componentPath: 'Employee/AttendanceManagement/RegisterEmployeesList'},
    //Leave List
    // { path: "/employee_info/leave_list", name: "Employee Leave List View", componentPath: 'Employee/Leave/LeaveSplitView'},
    { path: "/employee_info/leave_list/:type", name: "Employee Leave List View", componentPath: 'Employee/LMSNewTheme/ListView'},
    { path: "/employee_info/ot_list/:type", name: "Employee OT List View", componentPath: 'Employee/OTNewTheme/ListView'},
    // { path: "/employee_info/view_leave/:type/:id/:leave_id/:can_edit/:can_cancel/:can_approve/:request_cancel", name: "Employee Leave Details", componentPath: 'Employee/LMSNewTheme/LeaveDetails'},
    { path: "/employee_info/view_leave/:type/:id/:leave_id", name: "Employee Leave Details", componentPath: 'Employee/LMSNewTheme/LeaveDetails', meta: { requiresAuth: true }},
    { path: "/employee_info/check_available_leaves/:user_name/:type/:id?/:leave_id?", name: "Check Available Leaves", componentPath: 'Employee/LMSNewTheme/ViewAllLeaves', meta: { requiresAuth: true }},
    { path: "/employee_info/apply_leave/:id?/:leave_id?",  name: "Apply Leaves", componentPath: 'Employee/LMSNewTheme/ApplyLeave', meta: { requiresAuth: true }},
    { path: "/employee_info/apply_ot/:id?",  name: "Apply OT", componentPath: 'Employee/OTNewTheme/ApplyOT', meta: { requiresAuth: true }},
    { path: "/employee_info/view_ot/:type/:id",  name: "Employee OT Details", componentPath: 'Employee/OTNewTheme/OTDetails', meta: { requiresAuth: true }},
    // { path: "/employee_info/view_ot/:type/:id?",  name: "Employee OT Details", componentPath: 'Employee/OTNewTheme/OTDetails'},

    { path: "/employee_info/employee_leave_list", name: "Employee Leave List", componentPath: 'Employee/Leave/EmployeeLeaveListView'},
    // { path: "/employee_info/hr_attendance/:id", name: "HR Attendance", componentPath: 'Employee/attendanceListView'},
    // Assets List
    { path: "/employee_info/assets_list", name: "Employee Assets", componentPath: 'Employee/AssetsNewTheme/ListView'},
    { path: '/assetdashboard', name: 'Asset Dashboard', componentPath: 'Dashboard/Assets/AdminAssetsDashboard' },
    // { path: "/employee_info/assets_list", name: "Employee Assets", componentPath: 'Employee/AssetListView'},
    { path: "/employee_info/asset_details/:employee_name/:id", name: "Employee Asset By Details", componentPath: 'Employee/AssetsNewTheme/DetailsView'},
    // View Employee Info
    { path: "/employee_info/view_employee/:id/:my_profile/:is_draft", name: "View Employee", componentPath: 'Employee/ViewEmployeeDetails/ViewEmployee'},
    { path: "/employee_info/view_my_profile/:id/:my_profile/:is_draft", name: "View Employee", componentPath: 'Employee/ViewEmployeeDetails/ViewMyDetails'},

    // Email Redirection
    { path: "/employee_info/overtime_log_details/:comp_id/:user_id/:id", name: "Employee Overtime log Details" , componentPath: 'Employee/ViewSwitchCompany', meta: { requiresAuth: true }},
    { path: "/employee_info/leave_request_details/:comp_id/:user_id/:id", name: "Employee Leave log Details", componentPath: 'Employee/ViewSwitchCompany', meta: { requiresAuth: true }},

    // ==============  Job Portal ====================//

    { path: "/job_portal", name: "Job Portal", componentPath: 'HelloWorld', meta: { requiresAuth: true }},

    // ==============  Policies ====================//

    { path: "/policies", name: "Policies", componentPath: 'HelloWorld', meta: { requiresAuth: true }},

    // ==============  Face Recognition ====================//
    { path: "/face_recognition", name: "Face Recognition", componentPath: 'FaceRecognition/FaceRecognitionApp' },
    { path: "/face_liveness",    name: "Face Liveness",    componentPath: 'FaceRecognition/FaceLivenessApp' },

    // ==============  Settings ====================//

    // { path: "/settings", name: "Settings", componentPath: 'Settings/Settings'},
    { path: "/settings", name: "Settings", componentPath: 'SettingsNewTheme/Settings'},
    { path: "/settings/view_holidays_data", name: "Settings Holidays", componentPath: 'Employee/ViewEmployeeHolidays'},
    
    // ============== Travel Registry ====================//
    { path: "/travel_registry/create", name: "CreateTravel", componentPath: 'Employee/Travel/CreateTravel'},
    { path: "/travel_registry/list", name: "TravelListView", componentPath: 'Employee/Travel/TravelListview'},
    { path: "/travel_registry/view/:id", name: "TravelView", componentPath: 'Employee/Travel/ViewTravelRegistry'},
    { path: "/draft_travel_registry/view/:id", name: "DraftTravelView", componentPath: 'Employee/Travel/DraftViewTravelRegistry'},
    { path: "/travel_registry/edit/:id", name: "EditTravelView", componentPath: 'Employee/Travel/EditTravelRegistry'},
    { path: "/draft_travel_registry/edit/:id", name: "EditDraftTravelView", componentPath: 'Employee/Travel/DraftEditTravelRegistry'},


    // ============== DigiBooks ====================//
    { path: "/books/getting_started", name: "GettingStarted", componentPath: 'Books/Home/GettingStarted'},

    { path: "/books/listview/items", name: "Items", componentPath: 'Books/ListView/Items'},
    { path: "/books/listview/customers", name: "Customers", componentPath: 'Books/ListView/Customers'},
    { path: "/books/listview/vendors", name: "Vendors", componentPath: 'Books/ListView/Vendors'},

    { path: "/books/projectworkflow/create_project", name: "CreateProject", componentPath: 'Books/ProjectWorkflow/CreateProject'},
    { path: "/books/projectworkflow/workflow", name: "Workflow", componentPath: 'Books/ProjectWorkflow/Workflow'},

    { path: "/books/banking/connect_finances", name: "ConnectFinances", componentPath: 'Books/Banking/ConnectFinances'},
    { path: "/books/banking/banking_overview", name: "BankingOverview", componentPath: 'Books/Banking/BankingOverview'},
    { path: "/books/banking/add_manually_accounts_cards", name: "AddManuallyAccountsCards", componentPath: 'Books/Banking/AddManuallyAccountsCards'},
    { path: "/books/banking/connect_accounts_cards", name: "ConnectAccountsCards", componentPath: 'Books/Banking/ConnectAccountsCards'},
    { path: "/books/banking/import_statements", name: "ImportStatements", componentPath: 'Books/Banking/ImportStatements'},
    { path: "/books/banking/map_fields", name: "MapFields", componentPath: 'Books/Banking/MapFields'},

    { path: "/facerecognize", name: "FaceDetection", componentPath: 'HumanFace/faceCapture'},
    { path: "/facerecognizes", name: "FaceDetections", componentPath: 'HumanFace/face'},


    // ==============  Login and Verification ====================//
    // { path: "/login", name: "Login", componentPath: 'Login/Login'},
    { path: "/login", name: "Login", componentPath: 'Login/LoginLibrary'},

    // { path: "/user/verify", name: "VerifyUser", componentPath: 'VerifyUser' },
    { path: "/verifyOtp", name: "OtpVerify", componentPath: 'OtpVerify', meta: { requiresAuth: false } },

    // Access Denied
    // { path: '/subscription', name: 'AccessDenied', componentPath: 'AccessDenied'},

    // ***** Use other routes above this line only if you have a specific need *****

    // ================================================= Page Not Found ==============================================================
    {path:'/pagenotfound', name:'PageNotFound', componentPath: 'PageNotFound', meta: { requiresAuth: false }},

    {path:'*', name:'PageNotFoundError', redirect: '/pagenotfound', meta: { requiresAuth: false }},

    // ==============  View Notification Detail View ====================//
    { path: '/notifications/detail', name: 'NotificationDetailsView', componentPath: 'Notification/NotificationDetailsView'},
    { path: '/notifications_page', name: 'NotificationsPage', componentPath: 'Notification/NotificationDetailsView'}
]

const routes = routerOptions.map(route => {
    return {
        ...route,
        component: () => import(`@/components/${route.componentPath}.vue`)
    }
})

Vue.use(Router)

function isAuthenticated() {
    return VueCookie.get("Token") != null && VueCookie.get("Token") != ""
}

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: 'history'
})

// ==================== OLD CODE (Commented for reference) ====================
// Old navigation guard was commented out - it didn't properly capture intended destination
// This caused users clicking email links to always land on dashboard after login
/*
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated()) {
            next({
                path: '/login',
            });
        } else {
            if(to.name == "Login" && isAuthenticated()){
                next({
                    path: '/'
                });
            }
            next();
        }
    } else {
        if(to.name == "Login" && isAuthenticated()){
            next({
                path: '/'
            });
        }
        next()
    }
});
*/
// ==================== END OLD CODE ====================

// ==================== NEW CODE (Deep Linking Support) ====================
// Modified navigation guard to capture intended destination and enable deep linking
// Now properly saves the full URL path and redirects users after successful login
router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/verifyOtp', '/pagenotfound'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = isAuthenticated();

    // If trying to access a protected page without authentication
    if (authRequired && !loggedIn) {
        const redirectPath = to.fullPath;
        
        // Only add redirect_to if destination is not the home page
        // This keeps the login URL clean when user just goes to root
        if (redirectPath === '/') {
            return next({ path: '/login' });
        }
        
        // For all other pages (deep links, email links, etc), save the destination
        return next({
            path: '/login',
            query: { redirect_to: window.location.origin + redirectPath }
        });
    }

    // If already logged in and trying to access login page, redirect to home
    if (to.path === '/login' && loggedIn) {
        return next({ path: '/' });
    }

    // Role-based redirect: attendance_manager must go to their dashboard, not main dashboard
    // This prevents the main dashboard from mounting and firing its APIs unnecessarily
    if (to.path === '/' && loggedIn) {
        const userRole = store.state.loggedInUser?.user_role
        if (userRole === 'attendance manager') {
            return next({ path: '/attendance_management/dashboard' })
        }
    }

    // Continue to the requested page
    next();
});
// ==================== END NEW CODE ====================

export default router;
